import React from "react";
import isEmpty from "lodash/isEmpty";

export const getCarouselSlides = (format, isCarousel) => {
  // From Prismic we send empty objects which do not have images
  // due to lack of repeaters within repeaters we had to create 3 fields.
  // We want to filter out any image that is not populated in Prismic
  // in the case that the carousel only receives 2 images and not 3.
  return [format.image1, format.image2, format.image3]
    .filter((image) => image.url)
    .map((image, idx) => {
      return (
        <picture key={idx} className="GenericFormatSelector__card-picture">
          {image.mobile.url && !isCarousel && (
            <source media="(max-width: 777px)" srcSet={image.mobile.url} />
          )}
          <img
            className="GenericFormatSelector__card-image"
            src={image.url}
            alt={image.alt || ""}
            loading="lazy"
          />
        </picture>
      );
    });
};

export const joinAndSanitize = (commaSepratedString) => {
  return commaSepratedString
    ? commaSepratedString.split(",").map((s) => s.trim())
    : [];
};

// This hides formats based on some content in global content - we provide part of the id to match
// e.g. layflat and then the website prefix to hide it on.  e.g. ie.  Make sure the right prefix in
// the right global content is used.
// Note there is similar functionality in: src/client/js/view/components/CreationForm/Formats/helpers.js
export const filterFormatsForLocale = (
  availableFormats,
  prismicGlobalContentModel,
  countryModel
) => {
  const generalContent = prismicGlobalContentModel.general;
  const formatsToHide =
    generalContent.formatsToHide &&
    joinAndSanitize(generalContent.formatsToHide); // ['layflat'] //
  const hideFormatsOnTheseWebsites =
    generalContent.hideFormatsOnTheseWebsites &&
    joinAndSanitize(generalContent.hideFormatsOnTheseWebsites); //['ie']
  const websitePrefix = countryModel.prefix;

  return availableFormats.reduce((formats, format) => {
    if (!(isEmpty(formatsToHide) || isEmpty(hideFormatsOnTheseWebsites))) {
      // check if the current website prefix is in the exclude list
      if (hideFormatsOnTheseWebsites.includes(websitePrefix)) {
        // check if the current format is excluded - we just to an includes to match,
        // say, the layflat part of the id
        const anyMatchingFormatsToHide = formatsToHide.find((formatMatch) =>
          format.formatId.includes(formatMatch)
        );

        if (anyMatchingFormatsToHide) {
          return formats;
        }
      }
    }

    return formats.concat(format);
  }, []);
};
